import React from 'react'
import { useHistory } from 'react-router-dom';
import RatingReportTypesView from "../../views/ver_24.10/ProgramRating/RatingReportTypes.view";

const RatingReportTypesPage= () =>{
    const history = useHistory();
    const actions = {
        navigateToCPCProgramRating: () => history.push('/dq_stars_rating/program/new'),
        navigateToDQProgramRating: () => history.push('/dq_rating/program/new'),
    };

    return(
        <>
            <div>
                <RatingReportTypesView
                    actions={actions}
                />
            </div>
        </>
    );
}

export default RatingReportTypesPage;